import { parseISO } from 'date-fns';

type DatePickerValue = string | null | { start: string | null; end: string | null };
type DatePickerSelectionMode = 'single' | 'range';
type DateFormatter = (date: Date) => string;

export function formatDatePickerLabel(
  value: DatePickerValue,
  selectionMode: DatePickerSelectionMode,
  formatDate: DateFormatter,
): string {
  if (selectionMode === 'range') {
    if (value && typeof value === 'object') {
      const { start, end } = value;

      if (start && end) {
        return `${formatDate(parseISO(start))} - ${formatDate(parseISO(end))}`;
      }

      if (start) {
        return `${formatDate(parseISO(start))} ...`;
      }
    }

    return 'Select dates';
  }

  if (typeof value === 'string') {
    return formatDate(parseISO(value));
  }

  return 'Select date';
}
